export default __webpack_public_path__ + "static/media/ff-finder-hover.24c8237d.svg";